





















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { importAllData } from '@/utils/api/setting'
import MyDialog from './MyDialog.vue'
import { ElLoadingComponent } from 'element-ui/types/loading'

type ImportFormat = 'JSON'

interface ImportForm {
  importFormat: ImportFormat
  fileName: string
  fileContent?: string
}

@Component({
  components: {
    MyDialog,
  },
})
export default class ImportData extends Vue {
  @Getter('currentTheme') private theme!: Theme

  @Prop({ default: false }) public visible!: boolean

  private showDialog: boolean = this.visible
  private confirmLoading: boolean = false
  private record: ImportForm = {
    importFormat: 'JSON',
    fileName: '',
  }

  @Watch('visible')
  private onVisibleChanged(val: boolean) {
    this.showDialog = val
  }

  private triggerFileInput() {
    ;(this.$refs.fileInput as HTMLInputElement).click()
  }

  private getFileData(e: Event) {
    const file = (e.target as HTMLInputElement).files?.[0]
    if (!file) return
    this.getFileContentByFileReader(file)
  }

  private getFileContentByFileReader(file: File) {
    let loading: ElLoadingComponent | undefined = undefined
    let reader = new FileReader()
    reader.readAsText(file)
    reader.onloadstart = () => {
      loading = this.$loading({
        target: '.import-data .el-dialog',
        spinner: 'el-icon-loading',
      })
    }
    reader.onloadend = () => {
      loading?.close()
    }
    reader.onerror = () => {
      this.$message.error(`${this.$t('connections.readFileErr')}${reader.error?.message}`)
    }
    reader.onload = () => {
      this.record.fileName = file.name
      this.record.fileContent = this.getDiffFormatData(reader.result as string)
    }
  }

  private getDiffFormatData(content: string): string | undefined {
    switch (this.record.importFormat) {
      case 'JSON':
        return this.getJSONData(content)
        break
      default:
        break
    }
  }

  private getJSONData(data: string): string {
    return data
  }

  private async importData() {
    this.confirmLoading = true
    if (!this.record.fileContent) {
      this.$message.error(this.$tc('connections.uploadFileTip'))
      return
    }
    importAllData(this.record.fileContent)
    this.confirmLoading = false
    this.$message.success(this.$tc('common.importSuccess'))
    this.resetData()
    setTimeout(() => {
      location.reload()
    }, 1000)
  }

  private resetData() {
    this.showDialog = false
    this.$emit('update:visible', false)
    this.record = {
      importFormat: 'JSON',
      fileName: '',
    }
  }
}
